import React, { useEffect, useState } from "react";
import ChartComponent from "../Highcharts/ChartComponent";
import {
  neglectedCasesBarConfig,
  sexualReproBarConfig,
} from "../Highcharts/chartconfig";
import axios from "axios";
import Loader from "./Loader";

function HumanRightsIssusesNeglect({ requestData }) {
  const [rightsData, setRightsData] = useState({});
  const [keys, setKeys] = useState([]);

  useEffect(() => {
    let requestBody = {
      communityId: "fee5c0c217af285485abb2e583cb806c",
      distributionOnCasesIdentifier: ["Neglect"],
      languageId: 1,
      serviceId: 458,
    };
    if (Object.keys(requestData).length > 0) {
      let oRequest = { ...requestBody, ...requestData };
      if (
        (requestData?.globalFilters?.dateFilter.to !== "" &&
          requestData?.globalFilters?.dateFilter.from !== "") ||
        (requestData.questionIds != null &&
          requestData.selectedOption != null) ||
        (requestData.subQuestionIds != null &&
          requestData.selectedOption != null) ||
        requestData.serviceIdFilter != null
      ) {
        getData(oRequest);
      }
    } else {
      getData(requestBody);
    }
  }, [requestData]);

  let getData = async (data) => {
    try {
      let res = await axios.post(
        `${process.env.REACT_APP_API_KEY}/opendashboard/distributionOfHumanRightsIssues `,
        data
      );
      let formatedData = res.data.data[0]["Neglect"];
      let sortedArray = Object.entries(formatedData)
      .sort((a, b) => b[1] - a[1]);
  
      let sortedFormatedData = Object.fromEntries(sortedArray);
      let humRightsArr = [];

      Object.keys(sortedFormatedData).forEach((key, index) => {
        let percentVal;
        if (sortedFormatedData[key] !== 0 && totalValue(sortedFormatedData) !== 0) {
          percentVal = Math.round(
            (sortedFormatedData[key] / totalValue(sortedFormatedData)) * 100
          );
        } else {
          percentVal = 0;
        }
        let obj = {
          percent: percentVal,
          y: sortedFormatedData[key],
        };
        humRightsArr = [...humRightsArr, obj];
      });

      setRightsData(humRightsArr);
      setKeys(Object.keys(sortedFormatedData));
    } catch (error) {
      console.log(error);
    }
  };

  const totalValue = (data) => {
    let values = Object.values(data);
    const sumWithIndictors = values.reduce(
      (accumulator, currentValue) => accumulator + currentValue,
      0
    );
    return sumWithIndictors;
  };

  return (
    <>
      {Object.keys(rightsData).length > 0 ? (
        // <ChartComponent options={stigmaBarConfig(rightsData, keys)} />
        <ChartComponent options={neglectedCasesBarConfig(rightsData, keys)} />
      ) : (
        <Loader />
      )}
    </>
  );
}

export default HumanRightsIssusesNeglect;
